import React from 'react';

import { NavLinkButton, Table } from '@shared/components/bootstrap';

import { Spinner } from '@admin/components/spinner';
import { thirdPartyTransferDetailsURL } from '@admin/config/routes';
import { client } from '@admin/libraries/apollo';
import { ThirdPartyTransferFragment, useThirdPartyTransfersQuery } from '@admin/schema';

import { getStateBadgeClass } from './state';

const Row: React.FC<{ thirdPartyTransfer: ThirdPartyTransferFragment }> = ({ thirdPartyTransfer }) => (
  <tr>
    <td>{thirdPartyTransfer.bookingPlatform}</td>
    <td>{thirdPartyTransfer.bookingNumber}</td>
    <td>
      {thirdPartyTransfer.originWarehouse.abbreviation} ➡️ {thirdPartyTransfer.destinationWarehouse.abbreviation}
    </td>
    <td>
      <span className={`badge ${getStateBadgeClass(thirdPartyTransfer.state)}`}>
        {thirdPartyTransfer.state.toUpperCase()}{' '}
      </span>
    </td>
    <td>
      {
        <>
          <div>{thirdPartyTransfer.formattedPickupDate}</div>
          {thirdPartyTransfer.formattedPickupTime && <div>{thirdPartyTransfer.formattedPickupTime}</div>}
        </>
      }
    </td>
    <td>
      {
        <>
          <div>{thirdPartyTransfer.formattedDeliveryDate}</div>
          {thirdPartyTransfer.formattedDeliveryTime && <div>{thirdPartyTransfer.formattedDeliveryTime}</div>}
        </>
      }
    </td>
    <td>{thirdPartyTransfer.carrier}</td>
    <td>{thirdPartyTransfer.formattedCost}</td>

    <td className="text-right">
      <NavLinkButton
        kind="primary"
        to={thirdPartyTransferDetailsURL(thirdPartyTransfer.account.id, thirdPartyTransfer.id)}
      >
        View
      </NavLinkButton>
    </td>
  </tr>
);

export const ThirdPartyTransfersList: React.FC<{ accountID: string | number }> = ({ accountID }) => {
  const { data, loading } = useThirdPartyTransfersQuery({ client, variables: { accountID: String(accountID) } });

  return (
    <>
      <Table responsive striped>
        <thead>
          <tr>
            <th>Booking Platform</th>
            <th>Booking Number</th>
            <th>Warehouses</th>
            <th>State</th>
            <th>Pickup SLA</th>
            <th>Delivery SLA</th>
            <th>Carrier</th>
            <th>Cost</th>
            <th className="text-right" />
          </tr>
        </thead>

        <tbody>
          {data?.thirdPartyTransfers?.map((thirdPartyTransfer) => (
            <Row key={thirdPartyTransfer.id} thirdPartyTransfer={thirdPartyTransfer} />
          ))}
        </tbody>
      </Table>
      {loading && <Spinner />}
    </>
  );
};
